var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"embed",style:({paddingBottom: _vm.ratio + '%'})},[_c('div',{staticClass:"embed-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }